

























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {FieldTooltip} from "wings-ui-components";

@Component({components: { FieldTooltip }})
export default class CascadingOptions extends Vue {
  @Prop({ required: true }) templateItem!: any;
  @Prop({ required: true }) isCascading!: boolean;
  @Prop({ required: true }) errors!: { [key: string]: string[] };

  get isCancelEnabled(): boolean {
    return !!this.templateItem.multichannelCancelByStatus;
  }

  @Watch('isCascading', { immediate: false })
  onChangeIsCascading(val?: boolean) {
    if(!val){
      this.templateItem.multichannelCancelByStatus = 0;
      this.templateItem.multichannelCancelStatuses = null;
    }
  }

  @Watch('templateItem.multichannelCancelByStatus', {immediate: false, deep: true})
  async onChangeCancelByStatus(val?: number) {
    if (!!this.templateItem.multichannelCancelStatuses && !!this.templateItem.multichannelCancelByStatus) return
    else {
      this.templateItem.multichannelCancelStatuses = val ? [3] : null;
    }
  }
}
